import { Component, Vue } from 'vue-property-decorator';
import { startCase } from 'lodash';
import moment from 'moment';
import { PRIZE_TYPES } from '@/constants';
import { cleanSettings } from '@/helpers';

interface TypeOption {
  text: string;
  value: string;
}

@Component
export default class RewardPeriodForm extends Vue {
  $refs!: {
    formRef: HTMLFormElement;
  };

  private name = '';
  private description = '';
  private startDate = '';
  private endDate = '';
  private typeOptions: TypeOption[] = [];
  private settings: Record<string, any> = {};
  private ruleOptions = {
    name: [(v: string) => !!v || 'Reward period name is required'],
    startDate: [
      (v: string) => !!v || 'Start date is required',
      (v: string) => (v && this.validateDateFields()) || 'Start date must be before end date'
    ],
    endDate: [
      (v: string) => !!v || 'End date is required',
      (v: string) => (v && this.validateDateFields()) || 'End date must be after start date'
    ]
  };

  validateDateFields(): boolean {
    return !this.startDate || !this.endDate || moment(this.startDate).isBefore(moment(this.endDate));
  }

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  resetForm() : void {
    this.$refs.formRef.reset();
  }

  onSave(): void {
    if (this.formValidate()) {
      this.$emit('onSave', this.name, this.description, this.startDate, this.endDate, cleanSettings(this.settings));
      this.resetForm();
    }
  }

  onCancel(): void {
    this.$emit('onCloseDialog');
    this.resetForm();
  }

  created(): void {
    this.typeOptions = Object.keys(PRIZE_TYPES).map(pt => ({
      text: startCase(pt.toLowerCase()),
      value: pt
    }));
    // Initialize all settings keys for Vue 2 reactivity
    this.settings = {};
    for (const opt of this.typeOptions) {
      this.$set(this.settings, opt.value, '');
    }
  }
}
